module.exports = __webpack_public_path__ + "img/3.380842a2.jpg";